import React, { useState } from "react";
import PropTypes from "prop-types";
import { SketchPicker } from "react-color";

const popover = {
  position: "absolute",
  zIndex: "2",
};

const cover = {
  position: "fixed",
  top: "0px",
  right: "0px",
  bottom: "0px",
  left: "0px",
};

const button = {
  height: "38px",
  width: "38px",
  cursor: "pointer",
  position: "relative",
  outline: "none",
  borderRadius: "50%",
};

const ColorPicker = props => {
  const [isDisplayColorPicker, setDisplayColorPicker] = useState(false);
  const [color, setColor] = useState(() => props.value);

  const handleChange = value => {
    const rgba = `rgba(${value.rgb.r}, ${value.rgb.g}, ${value.rgb.b}, ${value.rgb.a})`;
    setColor(rgba);
    props.onChange(rgba);
  };

  return (
    <>
      <div style={{ display: "flex", gap: "12px" }}>
        {props.presetColors &&
          props.presetColors.map((c, index) => (
            <div
              key={index}
              onClick={() => {
                setColor(c);
                props.onChange(c);
              }}
              title={c}
              style={{
                ...button,
                backgroundColor: c,
                height: props.size || "38px",
                width: props.size || "38px",
              }}
            />
          ))}
        <div onClick={() => setDisplayColorPicker(true)}>
          <div
            title={color}
            style={{
              ...button,
              backgroundColor: props.presetColors ? "transparent" : color,
              backgroundImage: props.presetColors
                ? "url(/images/rainbow-flag.png)"
                : "",
              backgroundSize: "contain",
              height: props.size || "38px",
              width: props.size || "38px",
            }}
          />
        </div>
        {isDisplayColorPicker && (
          <div style={popover}>
            <div style={cover} onClick={() => setDisplayColorPicker(false)} />
            <SketchPicker color={color} onChange={handleChange} />
          </div>
        )}
      </div>
    </>
  );
};

ColorPicker.propTypes = {
  value: PropTypes.string.isRequired,
  size: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  presetColors: PropTypes.arrayOf(PropTypes.string),
};

export default ColorPicker;
